import axios from 'axios'
import qs from 'qs'
import Cookies from 'js-cookie'

import paramsUtil from './params'
import { getHeader, rejectHttpError } from './utils'

const baseURI = ''
const apiPrefix = '/wedu'

const instance = axios.create({
  baseURL: baseURI + apiPrefix,
  headers: {
    'x-requested-with': 'XMLHttpRequest',
    // 如果项目约定格式为 form，请修改 'Content-Type' 为: 'application/x-www-form-urlencoded'
    'Content-Type': 'application/json;charset=utf-8'
  },
  paramsSerializer(params) {
    params = paramsUtil.parseParams(params, { skipEmpty: true })

    // koa 使用 querystring.parse 解析
    // 'foo=bar&abc=xyz&abc=123' => { foo: 'bar', abc: ['xyz', '123'] }
    return qs.stringify(params, {
      arrayFormat: 'repeat',
      encoder: function (str) {
        return encodeURIComponent(str)
      }
    })
  },
  transformRequest(data, header) {
    const contentType = getHeader(header, 'content-type')
    const authorization = Cookies.get('Authorization') || ''
    const eduOrganization = Cookies.get('EDU-ORGANIZATION') || ''
      if (header['Authorization'] === undefined) {
          header['Authorization'] = authorization
      }
    header['EDU-ORGANIZATION'] = eduOrganization
    // 文件上传
    const isMultiPart = contentType === 'multipart/form-data'
    if (isMultiPart) {
      return data
    }

    data = paramsUtil.parseParams(data)
    if (data == null || typeof data === 'string') {
      return data
    }

    // 是否为表单模式
    const isForm = contentType === 'application/x-www-form-urlencoded'

    return isForm ? qs.stringify(data) : JSON.stringify(data)
  }
})

instance.interceptors.response.use(
  function (response) {
    let config = response.config
    let result = response.data
    if (!result) {
      return rejectHttpError('网络开小差了')
    }

    if (typeof result !== 'object') {
      return rejectHttpError('返回数据格式异常！')
    }

    if (
      [
        "/course_schedule/auth/do_class_course_schedule",
        "/auth/teacherSchedule/save_signle_course_schedule",
        "/auth/teacherSchedule/update_signle_course_schedule",
        "/course_schedule/auth/edit_course_schedule_info",
        "/course_schedule/auth/copy_course_schedule",
        "/course_schedule/auth/do_class_course_schedule"
      ].includes(config.url)
    ) {
      return result
    }

    if (!result.success || result.resultCode !== '0') {
      return rejectHttpError(result.message || '网络开小差了')
    }

    return result.data
  },
  function (error) {
    if (error.response) {
      const data = error.response.data
      const status = error.response.status
      if (status === 401) {
        Cookies.set('Authorization', '')
        Cookies.set('EDU-ORGANIZATION', '')
        sessionStorage.setItem('oldToken', '');
        sessionStorage.setItem('oldOrganization', '')
        location.reload()
        return
      }
      if (status === 429) {
        return rejectHttpError('请求过于频繁，服务器来不及反应啦')
      }
      if (status === 500 || status === 502 || status === 503 || status === 504) {
        return rejectHttpError('服务器开小差了，请稍后再试')
      }
      if (data) {
        return rejectHttpError(error.response.statusText, data)
      }
      return rejectHttpError('网络开小差了' + error.response.statusText)
    }

    if (error.request) {
      return rejectHttpError('网络开小差了：无返回结果')
    }

    return rejectHttpError(error.message)
  }
)

export default instance

// NOTE: 默认使用 application/json 格式
// 如果期望使用 form 格式
// 1. 如果大多数场景为 form 格式
// 请修改 axios.create 方法中的 'Content-Type': 'application/x-www-form-urlencoded'
// 2. 手工调用 form 格式
// axios.post(url, data, {
//   headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
// })
// 3. 封装 form 方法
// instance.postForm = function(url, data, config = {}) {
//   config.headers = config.headers || {}
//   config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
//   return this.post(url, data, config)
// }
